import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import { playerApi } from '@/api/endpoints';
import { isInTelegram } from './telegram';

/**
 * Bootstraps the user identity + decides which screen to show first.
 * Behaves like the old `initApp()` in app.js.
 */
export function useInitFlow() {
  const userId = useAuthStore((s) => s.userId);
  const initFromTelegram = useAuthStore((s) => s.initFromTelegram);
  const setScreen = useUIStore((s) => s.setScreen);
  const currentScreen = useUIStore((s) => s.currentScreen);

  // Step 1: read Telegram user (or fall back to debug login)
  useEffect(() => {
    if (userId) return;
    const ok = initFromTelegram();
    if (!ok && !isInTelegram()) {
      setScreen('debug-login');
    }
  }, [userId, initFromTelegram, setScreen]);

  // Step 2: once we have a userId, check if player exists on backend
  useEffect(() => {
    if (!userId) return;
    if (currentScreen !== 'loading' && currentScreen !== 'debug-login') return;
    let cancelled = false;
    (async () => {
      try {
        const data = await playerApi.get(userId);
        if (cancelled) return;
        if (data.exists) {
          setScreen('main');
        } else {
          setScreen('character-creation');
        }
      } catch (err) {
        console.error('[init] failed to fetch player:', err);
        if (!cancelled) {
          // Keep on loading; user can retry by reload. Could surface a toast.
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, currentScreen, setScreen]);
}
